import { useAuthStore } from '@/features/auth/store';

export function useAdminAuth() {
  const user = useAuthStore((s) => s.user);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)();

  // UserRole enum values: ADMIN | USER | MODERATOR | GUEST
  // PlatformAdmin records are granted to users with role === 'ADMIN'
  const isAdmin = isAuthenticated && user !== null && user.role === 'ADMIN';

  return { user, isAuthenticated, isAdmin };
}
